import React, { FunctionComponent } from 'react';

import { EditoLinkList as EditoLinkListType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import { graphql } from 'gatsby';

import BreakpointContainer from '../../BreakpointContainer';
import Content from './Content';
import Links from './Links';
import Title from './Title';
import UpperText from './UpperText';

export const EditoLinkListFragment = graphql`
  fragment EditoLinkListFragment on SanityEditoLinkList {
    title {
      title
      level
    }
    variant {
      variant
    }
    content: _rawContent
    upperText: upper_text
    links {
      text
      id: html_id
      href
      icon {
        type
      }
      internalRef: ref {
        ... on SanityArticle {
          slug {
            current
          }
        }
        ... on SanityCategory {
          slug {
            current
          }
        }
        ... on SanityPage {
          slug {
            current
          }
        }
      }
    }
  }
`;

const EditoLinkList: FunctionComponent<EditoLinkListType> = (props) => {
  const { content, upperText, links, title } = props;

  return (
    <BreakpointContainer maxWidth="xl" padding={[8, 4]}>
      <Flex flexDirection="column">
        <Title {...title} />
        <UpperText upperText={upperText} />
        <Flex flexDirection={{ xs: 'column', lg: 'row' }}>
          <Content content={content} />
          <Links links={links} />
        </Flex>
      </Flex>
    </BreakpointContainer>
  );
};

export default EditoLinkList;
